const state = {
  activeMenu: localStorage.activeMenu || "1",
};

const getters = {
  getMenu: ({ activeMenu }) => activeMenu,
};

const mutations = {
  setMenu(state, data) {
    state.activeMenu = data;
    localStorage.activeMenu = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
